import React, { useEffect, useState } from 'react'
import tw, { styled } from 'twin.macro'
import { motion, useMotionValue, animate, AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'

import useIsMounted from '@/hooks/useIsMounted'

import { claimSpiritStageAnimateAtom, claimSpiritStageAtom, ClaimSpiritStageEnum  } from './atoms/claimSpiritStageAtom'

const ImgWrapper = styled.div`
  width: 40vw;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  use-select: none;
`

const VideoSpirits = styled(motion.video)`
  ${tw`absolute flex justify-center items-center`}
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  width: 25%;
  mix-blend-mode: screen;
`

const ImgSpirits = styled(motion.img)`
  width: 100%;
  height: auto;
`

const ImgSpiritsHover = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;

  transition: 0.5s ease;

  &:hover {
    opacity: 1;
  }
`

const Spirits: React.FC = () => {
  const stage = useAtomValue(claimSpiritStageAtom)
  const variants = useAtomValue(claimSpiritStageAnimateAtom)

  const [showHoverImg, setshowHoverImg] = useState(false)
  const imgOpacity = useMotionValue(0)

  const isMounted = useIsMounted()
  useEffect(() => {
    if (isMounted) {
      animate(imgOpacity, 100)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    imgOpacity.onChange((latest) => {
      if (latest > 0.5) {
        setshowHoverImg(true)
      }
    })

    return () => {
      imgOpacity.destroy()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AnimatePresence mode="wait">
      {(stage === ClaimSpiritStageEnum.original || stage === ClaimSpiritStageEnum.defaults || stage === ClaimSpiritStageEnum.waiting) && (
        <ImgWrapper key="original">
          <ImgSpirits
            src="/static/images/indexPage/Spirit/step01_img_spirits_default.png"
            alt="spirit"
            style={{opacity: imgOpacity.get()/100}}
            initial="initial"
            animate="animate"
            exit="exit"
            variants={variants.spirits}
          />
          {showHoverImg && (
            <ImgSpiritsHover
              src="/static/images/indexPage/Spirit/step01_img_spirits_hover.png"
              alt="spirit-hover"
            />
          )}
        </ImgWrapper>
      )}
      {(stage === ClaimSpiritStageEnum.injected) && (
        <ImgWrapper key="injected">
          <ImgSpirits
            src="/static/images/indexPage/Spirit/step01_img_spirits_default.png"
            alt="spirit"
            style={{opacity: imgOpacity.get()/100}}
            initial="initial"
            animate="animate"
            exit="exit"
            variants={variants.spirits}
          />
          {showHoverImg && (
            <ImgSpiritsHover
              src="/static/images/indexPage/Spirit/step01_img_spirits_hover.png"
              alt="spirit-hover"
            />
          )}
        </ImgWrapper>
      )}
      {(stage === ClaimSpiritStageEnum.claimed) && (
        <VideoSpirits
          muted
          playsInline
          autoPlay
          loop
          initial="initial"
          animate="animate"
          exit="exit"
          variants={variants.spirits}
        >
          <source
            src="https://nft-assets.phala.world/artifacts/spirit.mp4"
            type="video/mp4"
          />
        </VideoSpirits>
      )}
    </AnimatePresence>
  )
}

export default Spirits
